export const SUGGESTIONS = {
  '/': [
    'What did he do at Bounteous?',
    'Show me projects from before LLMs',
    'Is he interviewing right now?',
  ],
  '/projects': [
    'Which project is he most proud of?',
    'What is graphrag-eval about?',
    'Anything shipped to production?',
  ],
  '/blog': [
    'Summarise this post in one line',
    'Why GraphRAG over plain RAG?',
    'What is post_save doing here?',
  ],
  '/experience': [
    'How long was he at Bounteous?',
    'Why did he leave?',
    'Search vs LLM experience - what mix?',
  ],
  '/education': [
    'What is his dissertation on?',
    'What did he study at Amrita?',
    'Which modules at DCU?',
  ],
  '/skills': [
    'Is he stronger in Java or Python?',
    'Which LLM stack does he actually use?',
    'What does he know about Canvas LMS?',
  ],
  '/contact': [
    'Best way to reach him?',
    'Is he open to remote?',
    'When can he start?',
  ],
  '/stats': [
    'How does this site actually work?',
    'Why Neo4j?',
    'What is in the graph right now?',
  ],
}

export const HEADLINE = {
  '/': 'On this page: bio · contact · what he is doing now.',
  '/projects': 'On this page: 5 projects · 2026 → 2022.',
  '/blog': 'On this page: blog posts · writing · thoughts.',
  '/experience': 'On this page: work experience · career timeline.',
  '/education': 'On this page: DCU M.Sc. AI · Amrita B.Tech CSE.',
  '/skills': 'On this page: the stack, grouped. Languages → infra.',
  '/contact': 'On this page: contact · hire · collaboration.',
  '/stats': 'On this page: the bits I built that no one asked for.',
}

export function getSuggestions(path) {
  return SUGGESTIONS[path] || SUGGESTIONS['/']
}

export function getHeadline(path) {
  return HEADLINE[path] || HEADLINE['/']
}
